import { Component,Input } from '@angular/core';
import * as _ from 'lodash'
import { NgIf } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../../../shared/components/ltms-loader/ltms-loader.component';

@Component({
    selector: 'app-action-summary-overall',
    templateUrl: './action-summary-overall.component.html',
    styleUrls: ['./action-summary-overall.component.scss'],
    imports: [NgIf, LtmsLoaderComponent]
})
export class ActionSummaryOverallComponent {
  @Input() totalResponses: string | null = '';
  @Input() totalActionableResponses: string | null = '';

  leftUpperBoxHeading: string = 'Actionable Issues';
  tatHours: any = 0;
  leftUpperBoxDiscription: string = 'Actionable Issues statistics based on current status.';
  
  constructor() {}   
}
